/**
 * Created by Administrator on 2017/8/24.
 */
import Vue from 'vue'
import vuex from 'vuex'
import userStore from './user'
import inventoryOverviewStore from './inventory-overview'
import inventoryTrendStore from './inventory-trend'
import notificationStore from './notification'
import permissionStore from './permission'
import dashboard from './dashboard'
import smile from './smile/smile'
import ccApplicationStore from './customer-code-application'

Vue.use(vuex)

export default new vuex.Store({
  modules: {
    user: userStore,
    inventoryOverview: inventoryOverviewStore,
    inventoryTrend: inventoryTrendStore,
    notification: notificationStore,
    permission: permissionStore,
    dashboard: dashboard,
    smile: smile,
    ccApplication: ccApplicationStore,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js